module.exports = __webpack_public_path__ + "img/checked.2e2d4867.svg";